import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Environment } from "../models/environment";

@Injectable({
    providedIn: 'root'
})
export class EnvironmentService {
    getEnvironment(): Environment {
        return environment
    }
} 